import {
  SAVE_CLIENT_STATUSES_LIST,
  SAVE_CLIENT_STATUS_DETAILS
} from 'redux/constants/ClientStatuses';

const theme = (state = {}, action) => {
  switch (action.type) {
  case SAVE_CLIENT_STATUSES_LIST:
    return {
      ...state,
      list: action.payload
    };
  case SAVE_CLIENT_STATUS_DETAILS:
    return {
      ...state,
      details: action.payload
    };
  default:
    return state;
  }
};

export default theme